import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { type FunctionComponent } from 'react';

type ImageProps = {
    className?: string;
};

const Image: FunctionComponent<ImageProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'image'}
            viewBox="0 0 250 250"
        >
            <path d="M245.3 43.7v147.7l-92.1-71.5-66.9 55.3-17.5-15.3-64.4 47.9v-164H250V39H-.3v170.6l-.1.1.1.2v7.4H250V39m-4.7 173.5H8l60.4-44.8 17.8 15.5 67.2-55.6 91.8 71.4v13.5h.1z" />
            <path d="M26.4 94.8c0 15.9 12.8 28.6 28.6 28.6s28.6-12.8 28.6-28.6S70.8 66.2 55 66.2s-28.6 13-28.6 28.6zm52.6 0c0 14.1-10 23.9-23.9 23.9-13.7 0-23.9-10.9-23.9-23.9 0-15.1 12.8-23.9 25-23.9C68.3 70.9 79 83.2 79 94.8z" />
        </svg>
    );
};
export default Image;
